import React from 'react'
import { ThemeProvider } from 'styled-components'
import useDarkPreference from '@talus-analytics/library.hooks.use-dark-preference'
import PaletteProvider, { PaletteOptions } from './PaletteProvider'

import textStyles from './textStyles'
import { ConfigStyles } from './types'

import './fonts.css'
import './normalize.css'
import './global.scss'

interface StylesProviderProps {
  styles: ConfigStyles
  children: React.ReactNode
}
const StylesProvider = ({
  styles,
  children,
}: StylesProviderProps): JSX.Element => {
  let theme: PaletteOptions = 'light'

  const userPrefersDark = useDarkPreference()

  // if no default palette specified, prefer system user preferences
  if (styles.defaultPalette === 'none') {
    theme = userPrefersDark ? 'dark' : 'light'
    // both light and dark palettes are required if default is none
    if (styles.palettes[theme] === undefined) {
      throw new Error(
        `Default color palette provided is: 'none', ` +
          `which means that both 'light' and 'dark' palettes are ` +
          `required. Please make sure that both palettes were specified ` +
          `in 'adlib-config.json' file, or specify a default palette to use.`
      )
    }
  }

  // otherwise, use specified
  else {
    theme = styles.defaultPalette
    // throw error if specified palette is undefined
    if (styles.palettes[theme] === undefined) {
      throw new Error(
        `Default color palette provided is: '${styles.defaultPalette}', ` +
          `but no corresponding '${styles.defaultPalette}' palette ` +
          `was specified in 'adlib-config.json' file.`
      )
    }
  }
  // if(styles.defaultPalette === "none")
  const themeExtended = {
    ...styles.palettes[theme],
    ...textStyles,
  }
  return (
    <ThemeProvider theme={themeExtended}>
      <PaletteProvider palette={theme}>
        <>{children}</>
      </PaletteProvider>
    </ThemeProvider>
  )
}

export default StylesProvider
